"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PulseTimeDimensionChangedEvent {
    constructor(timeDimension) {
        this._timeDimension = timeDimension;
    }
    get timeDimension() {
        return this._timeDimension;
    }
}
exports.PulseTimeDimensionChangedEvent = PulseTimeDimensionChangedEvent;
//# sourceMappingURL=PulseTimeDimensionChangedEvent.js.map